import MDInput from "components/MDInput"
import useNumberInput from "../hooks/useNumberInput"

// MDInput with thousands separators. `onChange` receives the raw string.
const MDNumberInput = ({ value, onChange, inputProps, ...rest }) => {
  const num = useNumberInput(value, onChange)
  return (
    <MDInput
      {...rest}
      inputRef={num.ref}
      value={num.value}
      onChange={num.onChange}
      onCompositionStart={num.onCompositionStart}
      onCompositionEnd={num.onCompositionEnd}
      inputProps={{ inputMode: "decimal", ...inputProps }}
    />
  )
}

export default MDNumberInput
